import ICONS from "../../../assets/Icons";
import CommonToast from "../CommonToast";

const UniversalRefreshToast = (titleInfo = "Refreshing balance") => {
  const toastMessage =
    titleInfo === "accountsRefresh"
      ? "Rejecting account."
      : titleInfo === "bulkStatement"
        ? "Uploading statement."
        : titleInfo === "bulkTxnStatement"
          ? "Uploading file."
          : titleInfo === "archive"
            ? "Archiving account."
            : titleInfo === "unarchive"
              ? "Unarchiving account."
              : titleInfo === "approvalaccountsRefresh"
                ? "Approving account."
                : titleInfo === "internalTxn"
                  ? "Rejecting transaction"
                  : titleInfo === "initializeTotp"
                    ? "Initializing TOTP"
                    : titleInfo === "unassignCate"
                      ? "Unassigning categories."
                      : titleInfo === "singleSchedule"
                        ? "Rejecting schedule."
                        : titleInfo === "multiSchedule"
                          ? "Rejecting schedules."
                          : titleInfo === "approveTxn"
                            ? "Approving transaction"
                            : titleInfo;
  return CommonToast({
    text: toastMessage,
    icon: ICONS?.LOADER_GIF,
    variant: "var(--processing)",
    buttonNeeded: false,
    btnProps: {
      enabledBgColor: "var(--primary-bg)",
      enabledTextColor: "var(--text-primary)",
      btnText: "",
      handleFunction: () => {},
      icon: "",
      btnType: "button",
      isDisabled: false,
      hoverOption: "white",
    },
  });
};

export default UniversalRefreshToast;
